export default "__VITE_ASSET__CIf1zLx8__"